{
	"en": {
		"common": {
			"app.title": "Drafter Application",
			"icon.home": "🏠",
			"button.home": "Home",
			"button.home.tooltip": "Go to Home",
			"icon.reset": "🔄",
			"button.reset": "Reset",
			"button.reset.tooltip": "Clear state, history, and return to home",
			"icon.about": "ℹ️",
			"button.about": "About",
			"button.about.tooltip": "Show the about page with application information",
			"icon.save": "💾",
			"button.save": "Save",
			"button.save.tooltip": "Save current state to local storage",
			"icon.load": "📂",
			"button.load": "Load",
			"button.load.tooltip": "Load previous state from local storage",
			"icon.download": "📥",
			"button.download": "Download",
			"button.download.tooltip": "Download current state as a JSON file",
			"icon.upload": "📤",
			"button.upload": "Upload",
			"button.upload.tooltip": "Upload a JSON file to restore state",
			"icon.toggle": "⚙️",
			"button.toggle": "Toggle",
			"button.toggle.tooltip": "Hide the debug panel (CTRL+Q twice to show again)",
			"icon.close": "❌",
			"button.close": "Close",
			"button.close.tooltip": "Close the server connection and this page.",
			"icon.edit": "📝",
			"button.edit": "Edit Source",
			"button.edit.tooltip": "Edit the source code and reload the site",
			"icon.exit_debug": "🚪",
			"button.exit_debug": "Production",
			"button.exit_debug.tooltip": "Exit debug mode and switch to production view",
			"editor.title": "Edit Source Code",
			"editor.run": "Run",
			"editor.cancel": "Cancel",
			"debug.tabs.label": "Debug panel sections",
			"debug.tab.current": "Current",
			"debug.tab.history": "History",
			"debug.tab.overview": "Overview",
			"debug.tab.tests": "Tests",
			"debug.tab.environment": "Environment",
			"menu.navigate": "Navigate",
			"menu.view": "View",
			"menu.edit": "Edit",
			"menu.saveload": "Save/Load",
			"menu.help": "Help",
			"icon.reload": "♻️",
			"menu.reload": "Reload Site",
			"menu.reload.tooltip": "Fully reload the page in the browser",
			"icon.replay": "🔁",
			"menu.replay": "Replay Route",
			"menu.replay.tooltip": "Run the current route again with the same arguments",
			"icon.toggle_frame": "🖼️",
			"menu.toggle_frame": "Toggle Frame",
			"menu.toggle_frame.tooltip": "Show or hide the application frame around the page",
			"icon.view_source": "📄",
			"menu.view_source": "View Page HTML",
			"menu.view_source.tooltip": "View the generated HTML of the current page (read-only)",
			"icon.switch_theme": "🎨",
			"menu.switch_theme": "Switch Theme…",
			"menu.switch_theme.tooltip": "Choose a different visual theme for the site",
			"theme.dialog.title": "Switch Theme",
			"theme.dialog.note": "The new theme applies immediately and is remembered for reloads.",
			"theme.current": "current",
			"theme.desc.default": "Drafter's clean built-in look",
			"theme.desc.none": "Bare, unstyled browser defaults",
			"theme.desc.7": "Glossy Windows 7 Aero glass",
			"theme.desc.98": "Retro Windows 98 desktop",
			"theme.desc.almond": "Soft neutral look, gentle blue accents",
			"theme.desc.brutal": "Neubrutalism: bold borders, hard shadows",
			"theme.desc.darkfairy": "Dark fairytale glow in pink",
			"theme.desc.daub": "Warm, earthy, hand-crafted feel",
			"theme.desc.latex": "Scholarly LaTeX paper typography",
			"theme.desc.magick": "Whimsical hand-drawn spellbook",
			"theme.desc.matcha": "Modern GitHub-flavored styling",
			"theme.desc.mvp": "Minimalist defaults with bright blue",
			"theme.desc.pico": "Elegant, polished semantic styling",
			"theme.desc.retro": "Terminal-green type on dark gray",
			"theme.desc.sakura": "Minimal off-white with teal accents",
			"theme.desc.simple": "Plain, readable, modern styling",
			"theme.desc.skeleton": "Light and airy, sky-blue buttons",
			"theme.desc.tacit": "Quiet gray-on-white simplicity",
			"theme.desc.terminal": "Amber-on-black coder terminal",
			"theme.desc.water": "Effortless dark-mode reading",
			"theme.desc.xp": "Nostalgic Windows XP blues",
			"theme.desc.yorha": "NieR-inspired beige military UI",
			"time.just_now": "just now",
			"time.minutes_ago": "{{n}} min ago",
			"time.hours_ago": "{{n}} hr ago",
			"time.days_ago": "{{n}} days ago",
			"viewsource.empty": "No page has been rendered yet.",
			"icon.edit_state": "🧮",
			"menu.edit_state": "Edit State…",
			"menu.edit_state.tooltip": "Edit the current state in a popup",
			"menu.quick_save": "Quick Save",
			"menu.save_slot": "Save to Slot…",
			"menu.load_recent": "Load Most Recent",
			"menu.load_slot": "Load from Slot…",
			"menu.download_snapshot": "Download Snapshot…",
			"menu.upload_snapshot": "Upload Snapshot…",
			"icon.documentation": "📚",
			"menu.documentation": "Documentation",
			"menu.documentation.tooltip": "Open the official Drafter documentation",
			"icon.bug_report": "🐞",
			"menu.bug_report": "Download Bug Report",
			"menu.bug_report.tooltip": "Download a bundle of debugging details that can be emailed with a bug report",
			"saveload.quick_slot": "Quick Save",
			"saveload.slot": "Slot",
			"saveload.slot_empty": "(empty)",
			"saveload.close": "Close",
			"saveload.nothing_saved": "Nothing has been saved yet.",
			"saveload.save_dialog.title": "Save to Slot",
			"saveload.load_dialog.title": "Load Saved State",
			"saveload.upload.title": "Upload Snapshot",
			"saveload.upload.instructions": "Choose a snapshot file that was previously downloaded from this menu.",
			"saveload.upload.invalid": "That file is not a valid Drafter snapshot.",
			"current.route": "Route:",
			"current.page_content": "Page Content",
			"current.problems": "Errors & Warnings",
			"current.no_problems": "No problems on this page 🎉",
			"current.problem_details": "Details",
			"current.diff.button": "🔍 Compare with previous state",
			"current.diff.tooltip": "Show what changed between the previous state and the current state",
			"current.diff.no_state": "No state has been recorded yet.",
			"current.diff.no_previous": "There is only one state so far — nothing to compare against.",
			"current.diff.identical": "The state did not change.",
			"current.diff.previous_label": "previous state",
			"current.diff.current_label": "current state",
			"packages.refresh": "🔄 Refresh",
			"packages.unavailable": "Package information is not available in this runtime.",
			"packages.none": "No packages have been loaded yet.",
			"packages.name": "Package",
			"packages.source": "Source",
			"storage.refresh": "🔄 Refresh",
			"storage.empty": "Browser storage is empty.",
			"storage.key": "Key",
			"storage.size": "Size",
			"storage.value": "Value",
			"storage.delete.tooltip": "Delete this stored value",
			"runtime.engine": "Engine",
			"runtime.browser": "Browser",
			"runtime.language": "Language",
			"runtime.pyodide_version": "Pyodide Version",
			"runtime.memory": "Memory",
			"runtime.uptime": "Uptime",
			"runtime.unknown_engine": "Unknown",
			"runtime.sample_value": "(coming soon)",
			"route_graph.coming_soon": "The route graph is coming soon! Here is a sample of what it will look like:",
			"coverage.coming_soon": "Coverage tracking is coming soon! Here is a sample of what it will look like:",
			"coverage.routes": "Routes visited",
			"coverage.state": "State fields tested",
			"coverage.code": "Code lines run",
			"test_wizard.coming_soon": "The guided test creator is coming soon! It will walk you through these steps:",
			"test_wizard.step_pick": "Pick a route and fill in its arguments",
			"test_wizard.step_run": "Run it and check the resulting page and state",
			"test_wizard.step_copy": "Copy the generated assert_equal into your code",
			"internals.summary": "Show Drafter internals",
			"internals.coming_soon": "Live internals inspection is coming soon! Sample of what will be shown:",
			"internals.sample_server": "Routes: 4 · State updates: 12 · Visits: 9",
			"internals.sample_bridge": "Shadow DOM: on · Debug panel: attached · Listeners: 8",
			"internals.sample_navigation": "Last request: guess (ID 12) · History entries: 9",
			"internals.sample_bus": "Subscribers: 3 · Events published: 87",
			"viewsource.title": "View Source Code",
			"viewsource.close": "Close",
			"state_edit.title": "Edit State",
			"state_edit.coming_soon": "Editing the state directly is coming soon! For now, here is a preview of the current state:",
			"state_edit.no_state": "No state has been recorded yet.",
			"state_edit.close": "Close",
			"footer.status.tooltip": "Errors and warnings on this page — click to open the Current tab",
			"footer.route": "Route: ",
			"footer.persisted": "Persisted",
			"footer.persisted.tooltip": "Show components persisting across page reloads",
			"footer.persisted.empty": "No persisted components",
			"footer.persisted.evict": "Remove",
			"footer.persisted.evict.tooltip": "Stop and discard this persisted component",
			"footer.persisted.reveal": "Reveal",
			"footer.persisted.reveal.tooltip": "Show/hide the persisted components in the footer",
			"console.title": "Console",
			"console.toggle.tooltip": "Show/hide the printed output console",
			"console.clear": "Clear",
			"console.clear.tooltip": "Clear the console output",
			"console.hide": "Hide",
			"console.hide.tooltip": "Hide the console until new output is printed or it is toggled back on",
			"console.input.placeholder": "Type Python code and press Enter"
		}
	},
	"es": {
		"common": {
			"app.title": "Aplicación Drafter",
			"icon.home": "🏠",
			"icon.reset": "🔄",
			"button.reset": "Reiniciar",
			"button.home": "Inicio",
			"icon.save": "💾",
			"button.save": "Guardar",
			"icon.load": "📂",
			"button.load": "Cargar",
			"icon.download": "📥",
			"button.download": "Descargar",
			"icon.upload": "📤",
			"button.upload": "Subir",
			"icon.toggle": "⚙️",
			"button.toggle": "Alternar",
			"icon.exit_debug": "🚪",
			"button.exit_debug": "Producción",
			"icon.close": "❌",
			"button.close": "Cerrar",
			"debug.tabs.label": "Secciones del panel de depuración",
			"debug.tab.current": "Actual",
			"debug.tab.history": "Historial",
			"debug.tab.overview": "Resumen",
			"debug.tab.tests": "Pruebas",
			"debug.tab.environment": "Entorno",
			"menu.navigate": "Navegar",
			"menu.view": "Ver",
			"menu.edit": "Editar",
			"menu.saveload": "Guardar/Cargar",
			"menu.help": "Ayuda",
			"icon.reload": "♻️",
			"menu.reload": "Recargar Sitio",
			"menu.reload.tooltip": "Recargar completamente la página en el navegador",
			"icon.replay": "🔁",
			"menu.replay": "Repetir Ruta",
			"menu.replay.tooltip": "Ejecutar de nuevo la ruta actual con los mismos argumentos",
			"icon.toggle_frame": "🖼️",
			"menu.toggle_frame": "Alternar Marco",
			"menu.toggle_frame.tooltip": "Mostrar u ocultar el marco de la aplicación alrededor de la página",
			"icon.view_source": "📄",
			"menu.view_source": "Ver HTML de la Página",
			"menu.view_source.tooltip": "Ver el HTML generado de la página actual (solo lectura)",
			"icon.switch_theme": "🎨",
			"menu.switch_theme": "Cambiar Tema…",
			"menu.switch_theme.tooltip": "Elegir un tema visual diferente para el sitio",
			"theme.dialog.title": "Cambiar Tema",
			"theme.dialog.note": "El nuevo tema se aplica de inmediato y se recuerda al recargar.",
			"theme.current": "actual",
			"theme.desc.default": "El estilo integrado y limpio de Drafter",
			"theme.desc.none": "HTML sin estilos, valores del navegador",
			"theme.desc.7": "Brillante cristal Aero de Windows 7",
			"theme.desc.98": "Escritorio retro de Windows 98",
			"theme.desc.almond": "Aspecto neutro y suave con acentos azules",
			"theme.desc.brutal": "Neobrutalismo: bordes gruesos, sombras duras",
			"theme.desc.darkfairy": "Cuento de hadas oscuro en rosa",
			"theme.desc.daub": "Cálido, terroso y artesanal",
			"theme.desc.latex": "Tipografía académica estilo LaTeX",
			"theme.desc.magick": "Grimorio caprichoso dibujado a mano",
			"theme.desc.matcha": "Estilo moderno tipo GitHub",
			"theme.desc.mvp": "Minimalista con azul brillante",
			"theme.desc.pico": "Estilo semántico, elegante y pulido",
			"theme.desc.retro": "Texto verde terminal sobre gris oscuro",
			"theme.desc.sakura": "Blanco suave con acentos verdeazulados",
			"theme.desc.simple": "Estilo moderno, sencillo y legible",
			"theme.desc.skeleton": "Ligero y aireado, botones celestes",
			"theme.desc.tacit": "Simplicidad discreta en gris y blanco",
			"theme.desc.terminal": "Terminal ámbar sobre negro",
			"theme.desc.water": "Modo oscuro sencillo y cómodo",
			"theme.desc.xp": "Nostálgico azul de Windows XP",
			"theme.desc.yorha": "Interfaz militar beige inspirada en NieR",
			"time.just_now": "ahora mismo",
			"time.minutes_ago": "hace {{n}} min",
			"time.hours_ago": "hace {{n}} h",
			"time.days_ago": "hace {{n}} días",
			"viewsource.empty": "Aún no se ha generado ninguna página.",
			"icon.edit_state": "🧮",
			"menu.edit_state": "Editar Estado…",
			"menu.edit_state.tooltip": "Editar el estado actual en una ventana emergente",
			"menu.quick_save": "Guardado Rápido",
			"menu.save_slot": "Guardar en Ranura…",
			"menu.load_recent": "Cargar Más Reciente",
			"menu.load_slot": "Cargar desde Ranura…",
			"menu.download_snapshot": "Descargar Captura…",
			"menu.upload_snapshot": "Subir Captura…",
			"icon.documentation": "📚",
			"menu.documentation": "Documentación",
			"menu.documentation.tooltip": "Abrir la documentación oficial de Drafter",
			"icon.bug_report": "🐞",
			"menu.bug_report": "Descargar Informe de Error",
			"menu.bug_report.tooltip": "Descargar un paquete de detalles de depuración que puede enviarse con un informe de error",
			"saveload.quick_slot": "Guardado Rápido",
			"saveload.slot": "Ranura",
			"saveload.slot_empty": "(vacía)",
			"saveload.close": "Cerrar",
			"saveload.nothing_saved": "Aún no se ha guardado nada.",
			"saveload.save_dialog.title": "Guardar en Ranura",
			"saveload.load_dialog.title": "Cargar Estado Guardado",
			"saveload.upload.title": "Subir Captura",
			"saveload.upload.instructions": "Elige un archivo de captura descargado previamente desde este menú.",
			"saveload.upload.invalid": "Ese archivo no es una captura válida de Drafter.",
			"current.route": "Ruta:",
			"current.page_content": "Contenido de la Página",
			"current.problems": "Errores y Advertencias",
			"current.no_problems": "No hay problemas en esta página 🎉",
			"current.problem_details": "Detalles",
			"current.diff.button": "🔍 Comparar con el estado anterior",
			"current.diff.tooltip": "Mostrar qué cambió entre el estado anterior y el estado actual",
			"current.diff.no_state": "Aún no se ha registrado ningún estado.",
			"current.diff.no_previous": "Solo hay un estado hasta ahora — no hay nada con qué comparar.",
			"current.diff.identical": "El estado no cambió.",
			"current.diff.previous_label": "estado anterior",
			"current.diff.current_label": "estado actual",
			"packages.refresh": "🔄 Actualizar",
			"packages.unavailable": "La información de paquetes no está disponible en este entorno.",
			"packages.none": "Aún no se ha cargado ningún paquete.",
			"packages.name": "Paquete",
			"packages.source": "Fuente",
			"storage.refresh": "🔄 Actualizar",
			"storage.empty": "El almacenamiento del navegador está vacío.",
			"storage.key": "Clave",
			"storage.size": "Tamaño",
			"storage.value": "Valor",
			"storage.delete.tooltip": "Eliminar este valor almacenado",
			"runtime.engine": "Motor",
			"runtime.browser": "Navegador",
			"runtime.language": "Idioma",
			"runtime.pyodide_version": "Versión de Pyodide",
			"runtime.memory": "Memoria",
			"runtime.uptime": "Tiempo activo",
			"runtime.unknown_engine": "Desconocido",
			"runtime.sample_value": "(próximamente)",
			"route_graph.coming_soon": "¡El grafo de rutas llegará pronto! Aquí hay una muestra de cómo se verá:",
			"coverage.coming_soon": "¡El seguimiento de cobertura llegará pronto! Aquí hay una muestra de cómo se verá:",
			"coverage.routes": "Rutas visitadas",
			"coverage.state": "Campos de estado probados",
			"coverage.code": "Líneas de código ejecutadas",
			"test_wizard.coming_soon": "¡El creador guiado de pruebas llegará pronto! Te guiará por estos pasos:",
			"test_wizard.step_pick": "Elige una ruta y completa sus argumentos",
			"test_wizard.step_run": "Ejecútala y revisa la página y el estado resultantes",
			"test_wizard.step_copy": "Copia el assert_equal generado en tu código",
			"internals.summary": "Mostrar los internos de Drafter",
			"internals.coming_soon": "¡La inspección de internos en vivo llegará pronto! Muestra de lo que se verá:",
			"internals.sample_server": "Rutas: 4 · Actualizaciones de estado: 12 · Visitas: 9",
			"internals.sample_bridge": "Shadow DOM: activado · Panel de depuración: adjunto · Escuchas: 8",
			"internals.sample_navigation": "Última petición: guess (ID 12) · Entradas de historial: 9",
			"internals.sample_bus": "Suscriptores: 3 · Eventos publicados: 87",
			"viewsource.title": "Ver Código Fuente",
			"viewsource.close": "Cerrar",
			"state_edit.title": "Editar Estado",
			"state_edit.coming_soon": "¡La edición directa del estado llegará pronto! Por ahora, aquí hay una vista previa del estado actual:",
			"state_edit.no_state": "Aún no se ha registrado ningún estado.",
			"state_edit.close": "Cerrar",
			"footer.status.tooltip": "Errores y advertencias en esta página — haz clic para abrir la pestaña Actual",
			"console.title": "Consola",
			"console.toggle.tooltip": "Mostrar/ocultar la consola de salida impresa",
			"console.clear": "Limpiar",
			"console.clear.tooltip": "Borrar la salida de la consola",
			"console.hide": "Ocultar",
			"console.hide.tooltip": "Ocultar la consola hasta que se imprima nueva salida o se vuelva a activar",
			"console.input.placeholder": "Escribe código Python y presiona Enter"
		}
	}
}
